import { Roles } from "../store/auth/models/internal";

export abstract class AndOrTreeNode {
  abstract exec(list: Array<typeof Roles.T>): boolean;
}

export class And extends AndOrTreeNode {
  private readonly x: AndOrTreeNode[];
  constructor(...x: AndOrTreeNode[]) {
    super();
    this.x = x;
  }

  exec(list: Array<typeof Roles.T>): boolean {
    return this.x.every((y) => y.exec(list));
  }
}

export class Or extends AndOrTreeNode {
  private readonly x: AndOrTreeNode[];
  constructor(...x: AndOrTreeNode[]) {
    super();
    this.x = x;
  }

  exec(list: Array<typeof Roles.T>): boolean {
    return !!this.x.find((y) => y.exec(list));
  }
}

export class LeafRole extends AndOrTreeNode {
  constructor(private readonly x: typeof Roles.T) {
    super();
  }

  exec(list: Array<typeof Roles.T>): boolean {
    return !!list.includes(this.x);
  }
}
